import * as Cart from '../utils/cartHelper'
import {validateCoupon} from '../services/discounts';

export const MODIFY_CART_ATTRIBUTE = 'MODIFY_CART_ATTRIBUTE';
export const REMOVE_CART_ATTRIBUTE = 'REMOVE_CART_ATTRIBUTE';
export const LOAD_CART = 'LOAD_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const VALIDATE_COUPON = 'VALIDATE_COUPON';


export function modifyCartAttribute(attribute, data) {

  let updatedCart = Cart.modifyCartAttribute(attribute, data);
  console.log("updated cart ........", updatedCart);
  return {
    type: MODIFY_CART_ATTRIBUTE,
    payload: updatedCart
  }
}

export function removeCartAttribute(attribute, data) {

  let updatedCart = Cart.removeCartAttribute(attribute, data);
  console.log("updated cart ........", updatedCart);
  return {
    type: REMOVE_CART_ATTRIBUTE,
    payload: updatedCart
  }
}

export function loadCart() {

  let cart = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_STORE);
  console.log("cart ........", cart);
  return {
    type: LOAD_CART,
    payload: cart
  }
}

export function clearCart() {
  return {
    type: CLEAR_CART
  }
}

export function applyDiscount(data, callback) {
  return dispatch => {
    dispatch({type: VALIDATE_COUPON})
    return validateCoupon(data).then(res => {
      dispatch({type: VALIDATE_COUPON, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: VALIDATE_COUPON, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/cartActions.js